import { Box, Button, Container, FormControlLabel, Grid, IconButton, InputAdornment, lighten, Paper, RadioGroup, Switch, Tab, Tabs, TextField, Tooltip, Typography, useMediaQuery } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { ReactComponent as VrLine } from '../../../assets/icons/main/verticalLine.svg';
import { ReactComponent as AssignIcon } from '../../../assets/icons/main/assign-icon.svg';
import { ReactComponent as ViewIcon } from '../../../assets/icons/main/view-icon.svg';
import { ReactComponent as AlertIcon } from '../../../assets/icons/main/alertIcon.svg';
import { ReactComponent as CreateIcon } from '../../../assets/icons/main/create-icon.svg';
import { ReactComponent as DeleteIcon } from '../../../assets/icons/main/delete-icon.svg';
import { ReactComponent as CloseIcon } from '../../../assets/icons/main/close-icon.svg';
import MultiSelect from '../../../components/MultiSelect';
import CustomDataTable from '../../../components/CustomDataTable';
import { ReactComponent as PlusCircleIcon } from '../../../assets/icons/main/plus-circle-icon.svg';
import PopUp from '../../../components/Popup';
import { cloneDeep, debounce, get, isEmpty, reduce } from 'lodash';
import { useLocation, useNavigate } from 'react-router-dom';
import Chip from '@mui/material/Chip';
import { useDispatch } from 'react-redux';
import { DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE } from '../../../utils/table-utils';
import RadioComponent from '../../../components/Radio';
import CalendarDateRange from '../components/CalendarDateRange';
import AssignTask from './assignTask';
import { maintenanceManagementActions } from '../../../store/reducers/maintenance-management';
import { palette } from '../../../theme/palette';
import { ontologyMasterActions } from '../../../store/reducers/ontology-master';
import { pageActions } from '../../../store/reducers/page-actions';
import Snackbar from '../../../common/snackBar';
import dayjs from 'dayjs';
import { dateFormater } from '../../../utils/time-converter';
import { useTheme } from '@emotion/react';
import lightOrdarkColor from '@check-light-or-dark/color';
import OntologySelector from '../../../common/OntologySelector';

const CustomStyle = {
    cellText: {
        fontSize: '16px',
        marginLeft: '10px',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        '&.disabled': {
            opacity: 0.5,
            userSelect: 'none',
        },
    },
    filterStyles: {
        '@media (max-width:1200px)': {
            paddingRight: '0px',
        },
        '@media (min-width:1201px) and (max-width:1375px)': {
            paddingRight: '100px',
        },
        '@media (min-width:1376px) and (max-width:1499px)': {
            paddingRight: '80px',
        },
        '@media (min-width:1498px) and (max-width:1615px)': {
            paddingRight: '60px',
        },
        '@media (min-width:1616px) and (max-width:1700px)': {
            paddingRight: '40px',
        },
        '@media (min-width:1701px) and (max-width:1900px)': {
            paddingRight: '20px',
        },
    },
};

const defaultPopupState: any = {
    show: false,
    title: '',
    message: '',
    confirmLabel: '',
    cancelLabel: '',
    confirmation: true,
    icon: '',
    onConfirm: null,
    cancel: true,
};

const priorityEnums: any = {
    1: 'High',
    2: 'Medium',
    3: 'Low'
};

const statusOptions = [
    { id: 0, label: 'All', value: 'all' },
    { id: 1, label: 'Active', value: true },
    { id: 2, label: 'Inactive', value: false },
];

const progressOptions = [
    { id: 0, label: 'All', value: 'all' },
    { id: 1, label: 'Complete', value: 'complete' },
    { id: 2, label: 'In Progress', value: 'in_progress' },
    { id: 3, label: 'Due', value: 'due' },
    { id: 4, label: 'Overdue', value: 'overdue' },
    { id: 5, label: 'On Hold', value: 'on_hold' },
];

interface FieldNameTypes {
    mt_name: string;
    onto_manage_id: string;
    last_task_date: string;
    next_task_date: string;
    is_active: string;
    mt_status: string;
    assign_to: string;
    priority: string;
    start_date: string;
    assigned_to_name: string;
}

const MaintenancePlans = ({
    ontologyData,
    ontologies,
    setSelectedRows,
    selectedRows,
    isMaintenanceListLoading,
    maintenancePlanData,
    maintenancePlanPageNumber,
    maintenancePlanTotalCount,
    deletePlanSuccess,
    updateMaintenancePlanLoading,
    updateMaintenancePlanSuccess,
    engineers
}: any) => {
    const today = new Date();
    const themeData: any = useTheme();
    const [filterObj, setFilterObj] = useState<any>({ mt_name: '', last_task_date: '', next_task_date: '', mt_status: [], is_active: [], assigned_to: [], priority: [], ontology: '' });
    const [selectedTab, setSelectedTab] = useState('preventive');
    const [assignTaskModal, setAssignTaskModal] = useState<any>(false);
    const [popupData, setPopupData] = useState<any>(defaultPopupState);
    const [confirmDeletePopup, setConfirmDeletePopup] = useState<any>({ show: false, mt: {} });
    const [sortingModel, setSortingModel] = useState({ field: '', sort: '' });
    const [params, setParams] = useState({});
    const [checked, setChecked] = useState(true);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [selectedOntology, setSelectedOntology] = useState<any>(0)
    const [planSearchValue, setPlanSearchValue] = useState<any>('');
    const [maintenanceData, setMaintenanceData] = useState<any>([]);
    const [dateRange, setDateRange] = useState({ start_date: dateFormater(new Date(new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7))), end_date: dateFormater(new Date(new Date(today.getFullYear(), today.getMonth(), today.getDate() + 7))) });
    const { pathname, state } = useLocation();
    const [deletePlanOccurance, setDeletePlanOccurance] = useState<any>('');
    const [assignTaskData, setAssignTaskData] = useState<any>({});
    const hideVerticalLine = useMediaQuery('(max-width:1200px)');

    // useEffect(()=>{
    //     setSelectedTab(pathname.split('/').length > 3 ? pathname.split('/')[3] === 'corrective' ? pathname.split('/')[3] : 'preventive' : 'preventive');
    //     dispatchMaintenanceRequest({
    //         mt_filter: pathname.split('/').length > 3 ? pathname.split('/')[3] === 'corrective' ? pathname.split('/')[3] : 'preventive' : 'preventive'
    //       });
    // },[pathname])

    const dispatchMaintenanceRequest = (payload: any) => {
        const arrayFilter = Object.keys(filterObj).reduce((acc: any, ele: any) => {
            acc[ele] = typeof filterObj[ele] === 'string' ? filterObj[ele] : filterObj[ele].join(', ')
            return acc
        }, {});

        const dispatchParams: any = {
            onto_manage_id: selectedOntology,
            search_item: planSearchValue,
            limit: DEFAULT_PAGE_SIZE,
            page: DEFAULT_PAGE_NUMBER,
            start_date: dateRange.start_date,
            end_date: dateRange.end_date,
            mt_filter: selectedTab,
            ...sortingModel,
            ...params,
            ...payload,
        }
        dispatch(
            maintenanceManagementActions.getMaintenaceTaskRequest(dispatchParams)
        );
    };

    useEffect(() => {
        const defaultTab = get(state, 'tab', pathname.split('/').length > 3 ? pathname.split('/')[3] === 'corrective' ? pathname.split('/')[3] : 'preventive' : 'preventive')
        if (defaultTab) {
            setSelectedTab(defaultTab);
            dispatchMaintenanceRequest({
                mt_filter: defaultTab,
                onto_manage_id: get(state, 'ontoId', 0),
            });
        }
        setSelectedOntology(get(state, 'ontoId', 0));
    }, []) //state

    useEffect(() => {
        if (pathname.length) {
            const pathnamesTemp: any = pathname.split('/').filter(Boolean);
            if (pathnamesTemp.length) {
                const pathnamesData: any = pathnamesTemp
                    .filter((i: any, index: number) => index != 2)
                    .map((item: any, index: number) => {
                        if (index == 0) {
                            return { route: pathnamesTemp[0], pathName: 'Maintenance Management', navigate: true };
                        } else if (index == 1) {
                            return { route: '', pathName: 'Maintenance Plans', navigate: false };
                        } else {
                            return { route: '', pathName: item, navigate: false };
                        }
                    });
                dispatch(pageActions.setPagePath(pathnamesData));
                return () => {
                    const data: any = [];
                    dispatch(pageActions.setPagePath(data));
                };
            }
        }
    }, [maintenanceData])

    useEffect(() => {
        dispatch(ontologyMasterActions.getOntologyList(''));
        dispatch(ontologyMasterActions.getOntologyMgmntList(''));
        dispatch(maintenanceManagementActions.getEngineersRequest({}));

        return () => {
            dispatch(maintenanceManagementActions.resetMaintenancePlanState());
        }
    }, [])

    useEffect(() => {
        if (maintenancePlanData.length > 0 && ontologies.length) {
            setMaintenanceData(
                maintenancePlanData.map((item: any) => {
                    return {
                        ...item,
                        ontologyList: getOntologyData(item.onto_manage_id),
                    };
                })
            );
        } else {
            setMaintenanceData([]);
        }
    }, [maintenancePlanData, ontologies]);

    useEffect(() => {
        if (updateMaintenancePlanSuccess) {
            dispatch(maintenanceManagementActions.resetMaintenancePlanState());
            Snackbar.success('Maintenance updated successfully!');
            dispatchMaintenanceRequest({});
            setAssignTaskModal(false)
            setAssignTaskData({})
        }
    }, [updateMaintenancePlanSuccess]);

    const getOntologyData = (ontoId: any) => {
        if (ontologies.length > 0) {
            let tempOntoData: any = [];
            restartTheLoop: while (true) {
                for (const item of ontologies) {
                    if (item.onto_manage_id == ontoId) {
                        tempOntoData.unshift(item);
                        ontoId = item.parent_id;
                        continue restartTheLoop;
                    }
                }
                break;
            }

            tempOntoData.map((item: any) => {
                let getLevelName = ontologyData.filter((data: any) => {
                    return data.id === item.onto_level_number;
                })[0];

                return {
                    ...item,
                    level_name: getLevelName?.level_name || '',
                };
            });

            return tempOntoData;
        }
        return [];
    };

    const getOntoSelectedValue = (e: any) => {
        setSelectedOntology(e?.onto_manage_id);
        dispatchMaintenanceRequest({
            onto_manage_id: e?.onto_manage_id
        });
    };

    const onChangeDispatch = useMemo(
        () =>
            debounce((params) => {
                const payload = reduce(
                    params,
                    (acc: any, value, key) => {
                        if (!isEmpty(value) && Array.isArray(value)) {
                            acc[key] = value.join(',');
                        }
                        if (!isEmpty(value) && typeof value === 'string' && value.trim()) {
                            acc[key] = value.trim();
                        }
                        return acc;
                    },
                    {}
                );
                setParams(payload);
                dispatchMaintenanceRequest({
                    limit: DEFAULT_PAGE_SIZE,
                    page: DEFAULT_PAGE_NUMBER,
                    ...payload,
                });
            }, 500),
        [sortingModel, planSearchValue, selectedOntology, dateRange, selectedTab]
    );

    const onSearch = (name: string, value: string) => {
        setFilterObj((pre: any) => ({ ...pre, [name]: value }));
        onChangeDispatch({ ...filterObj, [name]: value });
    };

    const engineerOptions = useMemo(() => {
        return engineers.map((engineer: any) => ({ ...engineer, label: engineer.full_name, value: engineer.id }));
    }, [engineers]);

    const filterRow = [
        {
            id: 1,
            field: 'mt_name',
            minWidth: '100px',
            renderCell: (params: any) => (
                <TextField
                    value={filterObj['mt_name']}
                    name={params.field}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => onSearch('mt_name', e.target.value)}
                    autoComplete='off'
                    sx={{ minWidth: '100px', width: 198 }}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position='end' sx={{ cursor: 'pointer' }}>
                                {filterObj['mt_name'] && (
                                    <CloseIcon style={{ height: '18px', width: '18px', color: palette.info.dark, opacity: '0.7' }} onClick={() => onSearch('mt_name', '')} />
                                )}
                            </InputAdornment>
                        ),
                    }}
                />
            ),
        },
        {
            id: 2,
            field: 'ontology',
            renderCell: (params: any) => (
                <TextField
                    value={filterObj['ontology']}
                    name={params.field}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => onSearch('ontology', e.target.value)}
                    autoComplete='off'
                    sx={{ minWidth: '100px', width: 165 }}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position='end' sx={{ cursor: 'pointer' }}>
                                {filterObj['ontology'] && (
                                    <CloseIcon style={{ height: '18px', width: '18px', color: palette.info.dark, opacity: '0.7' }} onClick={() => onSearch('ontology', '')} />
                                )}
                            </InputAdornment>
                        ),
                    }}
                />
            ),
        },
        {
            id: 3,
            field: 'last_task_date',
            // renderCell: (params: any) => (
            //     <TextField
            //         value={filterObj['last_task_date']}
            //         name={params.field}
            //         onChange={(e: React.ChangeEvent<HTMLInputElement>) => onSearch('last_task_date', e.target.value)}
            //         autoComplete='off'
            //         sx={{ minWidth: '100px', width: 165 }}
            //         InputProps={{
            //             endAdornment: (
            //                 <InputAdornment position='end' sx={{ cursor: 'pointer' }}>
            //                     {filterObj['last_task_date'] && (
            //                         <CloseIcon style={{ height: '18px', width: '18px', color: palette.info.dark, opacity: '0.7' }} onClick={() => onSearch('last_task_date', '')} />
            //                     )}
            //                 </InputAdornment>
            //             ),
            //         }}
            //     />
            // ),
        },
        {
            id: 4,
            field: 'next_task_date',
            minWidth: '100px',
            width: '150px',
            // renderCell: (params: any) => (
            //     <TextField
            //         value={filterObj['next_task_date']}
            //         name={params.field}
            //         onChange={(e: React.ChangeEvent<HTMLInputElement>) => onSearch('next_task_date', e.target.value)}
            //         autoComplete='off'
            //         sx={{ minWidth: '100px', width: 165 }}
            //         InputProps={{
            //             endAdornment: (
            //                 <InputAdornment position='end' sx={{ cursor: 'pointer' }}>
            //                     {filterObj['next_task_date'] && (
            //                         <CloseIcon style={{ height: '18px', width: '18px', color: palette.info.dark, opacity: '0.7' }} onClick={() => onSearch('next_task_date', '')} />
            //                     )}
            //                 </InputAdornment>
            //             ),
            //         }}
            //     />
            // ),
        },
        {
            id: 5,
            field: 'is_active',
            minWidth: '100px',
            width: '164px',
            renderCell: (params: any) => (
                <MultiSelect
                    showSelectedLabels
                    selectedOptions={filterObj['is_active']}
                    options={[
                        { id: true, name: true, label: 'Active', value: true },
                        { id: false, name: false, label: 'Inactive', value: false },
                    ]}
                    onChange={(value: string[]) => {
                        onFilter('is_active', value);
                    }}
                    width={params.width}
                />
            ),
        },
        {
            id: 6,
            field: 'mt_status',
            minWidth: '100px',
            width: '167px',
            renderCell: (params: any) => (
                <MultiSelect
                    selectedOptions={filterObj['mt_status']}
                    options={[
                        { id: 'completed', name: 'completed', label: 'Completed', value: 'completed' },
                        { id: 'in_progress', name: 'in_progress', label: 'In Progress', value: 'in_progress' },
                        { id: 'due', name: 'due', label: 'Due', value: 'due' },
                        { id: 'overdue', name: 'overdue', label: 'Overdue', value: 'overdue' },
                        { id: 'on_hold', name: 'on_hold', label: 'On Hold', value: 'on_hold' },
                    ]}
                    onChange={(value: string[]) => {
                        onFilter('mt_status', value);
                    }}
                    showSelectedLabels
                    width={params.width}
                />
            ),
        },
        {
            id: 7,
        },
        {
            id: 8,
            field: 'assigned_to',
            minWidth: '100px',
            width: '167px',
            renderCell: (params: any) => (
                <MultiSelect
                    showSearch
                    selectedOptions={filterObj['assigned_to']}
                    options={engineerOptions}
                    onChange={(value: string[]) => {
                        onFilter('assigned_to', value);
                    }}
                    showSelectedLabels
                    width={params.width}
                />
            ),
        },
    ];

    const correctiveFilterRow = [
        {
            id: 1,
            field: 'mt_name',
            minWidth: '100px',
            renderCell: (params: any) => (
                <TextField
                    value={filterObj['mt_name']}
                    name={params.field}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => onSearch('mt_name', e.target.value)}
                    autoComplete='off'
                    sx={{ minWidth: '100px', width: 198 }}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position='end' sx={{ cursor: 'pointer' }}>
                                {filterObj['mt_name'] && (
                                    <CloseIcon style={{ height: '18px', width: '18px', color: palette.info.dark, opacity: '0.7' }} onClick={() => onSearch('mt_name', '')} />
                                )}
                            </InputAdornment>
                        ),
                    }}
                />
            ),
        },
        {
            id: 2,
            field: 'ontology',

            renderCell: (params: any) => (
                <TextField
                    value={filterObj['ontology']}
                    name={params.field}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => onSearch('ontology', e.target.value)}
                    autoComplete='off'
                    sx={{ minWidth: '100px', width: 165 }}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position='end' sx={{ cursor: 'pointer' }}>
                                {filterObj['ontology'] && (
                                    <CloseIcon style={{ height: '18px', width: '18px', color: palette.info.dark, opacity: '0.7' }} onClick={() => onSearch('ontology', '')} />
                                )}
                            </InputAdornment>
                        ),
                    }}
                />
            ),
        },
        {
            id: 3,
            field: 'last_task_date',
            // renderCell: (params: any) => (
            //     <TextField
            //         value={filterObj['last_task_date']}
            //         name={params.field}
            //         onChange={(e: React.ChangeEvent<HTMLInputElement>) => onSearch('last_task_date', e.target.value)}
            //         autoComplete='off'
            //         sx={{ minWidth: '100px', width: 165 }}
            //         InputProps={{
            //             endAdornment: (
            //                 <InputAdornment position='end' sx={{ cursor: 'pointer' }}>
            //                     {filterObj['last_task_date'] && (
            //                         <CloseIcon style={{ height: '18px', width: '18px', color: palette.info.dark, opacity: '0.7' }} onClick={() => onSearch('last_task_date', '')} />
            //                     )}
            //                 </InputAdornment>
            //             ),
            //         }}
            //     />
            // ),

        },

        {
            id: 4,
            field: 'priority',
            minWidth: '100px',
            width: '164px',
            renderCell: (params: any) => (
                <MultiSelect
                    showSelectedLabels
                    selectedOptions={filterObj['priority']}
                    options={[
                        { id: 1, name: 'high', label: 'High', value: 1 },
                        { id: 2, name: 'medium', label: 'Medium', value: 2 },
                        { id: 3, name: 'low', label: 'Low', value: 3 },
                    ]}
                    onChange={(value: string[]) => {
                        onFilter('priority', value);
                    }}
                    width={params.width}
                />
            ),
        },
        {
            id: 6,
            field: 'mt_status',
            minWidth: '100px',
            width: '164px',
            renderCell: (params: any) => (
                <MultiSelect
                    selectedOptions={filterObj['mt_status']}
                    options={[
                        { id: 'completed', name: 'completed', label: 'Completed', value: 'completed' },
                        { id: 'in_progress', name: 'in_progress', label: 'In Progress', value: 'in_progress' },
                        { id: 'due', name: 'due', label: 'Due', value: 'due' },
                        { id: 'overdue', name: 'overdue', label: 'Overdue', value: 'overdue' },
                        { id: 'on_hold', name: 'on_hold', label: 'On Hold', value: 'on_hold' },
                    ]}
                    onChange={(value: string[]) => {
                        onFilter('mt_status', value);
                    }}
                    showSelectedLabels
                    width={params.width}
                />
            ),
        },
        {
            id: 7,
        },
        {
            id: 8,
            field: 'assigned_to',
            minWidth: '100px',
            width: '164px',
            renderCell: (params: any) => (
                <MultiSelect
                    showSearch
                    selectedOptions={filterObj['assigned_to']}
                    options={engineerOptions}
                    onChange={(value: string[]) => {
                        onFilter('assigned_to', value);
                    }}
                    showSelectedLabels
                    width={params.width}
                />
            ),
        },
    ];

    const onFilter = (selection: string, value: string | string[]) => {
        let filterData = {};
        setFilterObj((pre: any) => {
            filterData = {
                ...pre,
                [selection]: typeof value === 'string' ? pre[selection].filter((option: string) => option !== value) : value,
            };
            return { ...filterData };
        });
        onFilterDispatch(filterData);
    };

    const onFilterDispatch = (pars: any) => {
        const payload = reduce(
            pars,
            (acc: any, value, key) => {
                if (!isEmpty(value) && Array.isArray(value)) {
                    acc[key] = value.join(',');
                }
                if (!isEmpty(value) && typeof value === 'string' && value.trim()) {
                    acc[key] = value.trim();
                }
                return acc;
            },
            {}
        );
        setParams(payload);
        dispatch(
            maintenanceManagementActions.getMaintenaceTaskRequest({
                onto_manage_id: selectedOntology,
                search_item: planSearchValue,
                start_date: dateRange.start_date,
                end_date: dateRange.end_date,
                mt_filter: selectedTab,
                ...sortingModel,
                limit: DEFAULT_PAGE_SIZE,
                page: DEFAULT_PAGE_NUMBER,
                ...payload,
            })
        );
    };

    const onPlanNavigate = (type: string, mtId: number) => {
        navigate(`/maintenance-management/plan-list/${type}/${mtId}`, {
            state: {
                tab: selectedTab,
                from: selectedTab == 'corrective' ? 'plan-list/' + selectedTab : 'plan-list/',
                breadCrumbsName: 'Maintenance Plan'
            }
        });
    }

    const preventiveColumns: any = [
        {
            field: 'mt_name',
            headerName: 'Maintenance Name',
            sortable: true,
            resizable: false,
            flex: 1,
            customFilterReq: true,
            headerAlign: 'left',
            align: 'left',
            minWidth: 250,
            width: '150px',
            renderCell: (params: any) => {
                const isNotAllowed = !params.row.is_allowed;
                return (
                    <Box
                        sx={{
                            width: '240px',
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            position: 'relative',
                        }}
                    >
                        <Tooltip title={!isNotAllowed && params.value} arrow>
                            <Typography
                                component='span'
                                color='primary'
                                onClick={() => pageRedirect(params.row)}
                                sx={{
                                    cursor: 'pointer',
                                    fontWeight: 400,
                                    fontSize: '1rem',
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis',
                                    overflow: 'hidden',
                                    marginLeft: '10px',
                                }}
                            >
                                {params.value}
                            </Typography>
                        </Tooltip>
                    </Box>
                );
            },
        },
        {
            field: 'onto_manage_id',
            headerName: 'Location',
            flex: 1,
            sortable: true,
            resizable: false,
            customFilterReq: true,
            headerAlign: 'left',
            align: 'left',
            minWidth: 200,
            width: '200px',
            renderCell: (params: any) => {
                const ontoList =
                    params.row.ontologyList && params.row.ontologyList.length
                        ? params.row.ontologyList.map((item: any, index: number) =>
                            params.row.ontologyList.length > 1 ? (
                                index === params.row.ontologyList.length - 1 ? (
                                    <span>{item.onto_manage_title} </span>
                                ) : (
                                    <span>{item.onto_manage_title} / </span>
                                )
                            ) : (
                                <span>{item.onto_manage_title}</span>
                            )
                        )
                        : 'N/A';

                return (
                    <Box sx={{ textWrap: 'wrap', lineHeight: '1.2', width: '120px' }}>
                        <Tooltip title={ontoList} placement='left' arrow>
                            <Typography
                                component='p'
                                sx={{
                                    textOverflow: 'ellipsis',
                                    fontSize: '16px !important',
                                    fontWeight: '400',
                                    lineHeight: '1.5',
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                }}
                            >
                                {ontoList}
                            </Typography>
                        </Tooltip>
                    </Box>
                );
            },
        },
        {
            field: 'last_task_date',
            headerName: 'Last Maintenance',
            flex: 1,
            sortable: true,
            resizable: false,
            customFilterReq: true,
            headerAlign: 'left',
            align: 'left',
            minWidth: 200,
            width: '200px',
            renderCell: (params: any) => {
                return (
                    <Typography
                        component='p'
                        variant='subtitle1'
                        sx={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}
                    >
                        {params.value ? dayjs.utc(params.value).local().format('MMM D, YYYY hh:mm A') : 'N/A'}
                    </Typography>
                );
            },
        },
        {
            field: 'next_task_date',
            headerName: 'Next Maintenance',
            flex: 1,
            sortable: true,
            resizable: false,
            customFilterReq: true,
            headerAlign: 'left',
            align: 'left',
            minWidth: 200,
            width: '200px',
            renderCell: (params: any) => {
                const currentTaskDate = get(params, 'row.current_task_date', null);
                const nextTaskDate = currentTaskDate && new Date(currentTaskDate) > new Date() ? currentTaskDate : params.value

                return (
                    <Typography
                        component='p'
                        variant='subtitle1'
                        sx={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}
                    >
                        {nextTaskDate ? dayjs.utc(nextTaskDate).local().format('MMM D, YYYY hh:mm A') : 'N/A'}
                    </Typography>
                );
            },
        },
        {
            field: 'is_active',
            headerName: 'Active',
            flex: 1,
            sortable: true,
            resizable: false,
            colType: 'custom',
            headerAlign: 'left',
            align: 'center',
            customDropdownFilterReq: true,
            options: statusOptions,
            minWidth: 100,
            width: '200px',
            renderCell: (params: any) => {
                return (
                    <Switch
                        onClick={(e: React.MouseEvent<HTMLElement>) => {
                            e.stopPropagation();
                        }}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            setChecked(e.target.checked);
                            handleToggle(params.row, e.target.checked);

                            const row = cloneDeep(params.row)
                            const mtId = row.mt_id;
                            delete row.ontologyList;
                            delete row.mt_id;
                            const payload = new FormData();
                            payload.append('maintenance', JSON.stringify({ ...row, schedule_type:'occurrence', is_active: e.target.checked, current_task_date: get(row, 'current_task_date', null) }));
                            payload.append('maintenance_id', mtId);

                            dispatch(maintenanceManagementActions.updateMaintenancePlanRequest(payload));
                        }}
                        checked={params.value}
                    />
                );
            },
        },
        {
            field: 'mt_status',
            headerName: 'Status',
            flex: 1,
            sortable: true,
            resizable: false,
            colType: 'custom',
            headerAlign: 'left',
            align: 'left',
            customDropdownFilterReq: true,
            options: progressOptions,
            minWidth: 100,
            width: '200px',
            renderCell: (params: any) => {
                return (
                    <>
                        <Chip
                            label={params.value.replace('_', " ")}
                            className={params.value}
                            variant='outlined'
                            sx={{ padding: '0px 8px 0px 8px!important', width: '130px' }}
                        />
                    </>
                );
            },
        },
        {
            field: 'actions',
            headerName: 'ACTIONS',
            sortable: false,
            headerAlign: 'left',
            align: 'left',
            customFilterReq: false,
            width: '200px',
            renderCell: (params: any) => {
                const disableUpdate = false;
                const disableDelete = false;
                return (
                    <Box sx={{
                        display: 'flex',
                        gap: '16px'
                    }}>
                        <IconButton disableRipple sx={{ padding: 0 }} onClick={() => {onPlanNavigate('view', params.row.mt_id) }} disabled={disableUpdate}>
                            <ViewIcon
                                style={{
                                    cursor: 'pointer',
                                    width: 24,
                                    height: 24,
                                    opacity: disableUpdate ? 0.5 : 1,
                                    color: themeData.palette.custom.light
                                }}
                            />
                        </IconButton>
                        
                        <IconButton disableRipple sx={{ padding: 0 }} onClick={() => {
                            onPlanNavigate('edit', params.row.mt_id)
                        }} disabled={disableUpdate}>
                            <CreateIcon
                                style={{
                                    cursor: 'pointer',
                                    width: 24,
                                    height: 24,
                                    opacity: disableUpdate ? 0.5 : 1,
                                    color: themeData.palette.custom.light
                                }}
                            />
                        </IconButton>

                        <IconButton disableRipple sx={{ padding: 0 }} onClick={() => handleMultipleActions(params.row, 'delete')} disabled={disableDelete}>
                            <DeleteIcon
                                style={{
                                    cursor: 'pointer',
                                    width: 24,
                                    height: 24,
                                    opacity: disableDelete ? 0.5 : 1,
                                    color: themeData.palette.custom.light
                                }}
                            />
                        </IconButton>
                        <IconButton disableRipple sx={{ padding: 0 }} onClick={() => handleMultipleActions(params.row, 'assign')} disabled={disableUpdate}>
                            <AssignIcon
                                style={{
                                    cursor: 'pointer',
                                    width: 24,
                                    height: 24,
                                    opacity: disableUpdate ? 0.5 : 1,
                                    color: themeData.palette.custom.light
                                }}
                            />
                        </IconButton>

                    </Box>
                );
            },
        },
        {
            field: 'assigned_to_name',
            headerName: 'Assign To',
            flex: 1,
            sortable: true,
            resizable: false,
            colType: 'custom',
            headerAlign: 'left',
            align: 'left',
            customDropdownFilterReq: true,
            options: [],
            minWidth: 100,
            width: '210px',
            renderCell: (params: any) => {
                return (
                    <>
                        {(params.value && params.value.length) ? <Typography
                            component='span'
                            sx={CustomStyle.cellText}
                            fontWeight={400}
                        >
                            {params.value}
                        </Typography> : <Typography
                            component='span'
                            sx={CustomStyle.cellText}
                            fontWeight={400}
                        >
                            Not Assigned
                        </Typography>}
                    </>

                );
            },
        }
    ];

    const correctiveColumns: any = [
        {
            field: 'mt_name',
            headerName: 'Maintenance Name',
            sortable: true,
            resizable: false,
            flex: 1,
            customFilterReq: true,
            headerAlign: 'left',
            align: 'left',
            minWidth: 200,
            width: '200px',
            renderCell: (params: any) => {
                const isNotAllowed = !params.row.is_allowed;
                return (
                    <Box
                        sx={{ width: '240px', display: 'flex', flexDirection: 'row', alignItems: 'center', position: 'relative' }}
                    >
                        <Tooltip title={!isNotAllowed && params.value} arrow>
                            {
                                ['completed', 'on_hold'].includes(params.row.mt_status) ?
                                    <Typography
                                        component='span'
                                        color='primary'
                                        onClick={() => pageRedirect(params.row)}
                                        sx={{
                                            cursor: 'pointer',
                                            fontWeight: 400,
                                            fontSize: '1rem',
                                            whiteSpace: 'nowrap',
                                            textOverflow: 'ellipsis',
                                            overflow: 'hidden',
                                            marginLeft: '10px',
                                        }}
                                    >
                                        {params.value}
                                    </Typography>
                                    :
                                    <Typography
                                        component='span'
                                        sx={CustomStyle.cellText}
                                        fontWeight={400}
                                    >
                                        {params.value}
                                    </Typography>
                            }
                        </Tooltip>
                    </Box>
                );
            },
        },
        {
            field: 'onto_manage_id',
            headerName: 'Location',
            flex: 1,
            sortable: true,
            resizable: false,
            customFilterReq: true,
            headerAlign: 'left',
            align: 'left',
            minWidth: 200,
            width: '200px',
            renderCell: (params: any) => {
                const ontoList =
                    params.row.ontologyList && params.row.ontologyList.length
                        ? params.row.ontologyList.map((item: any, index: number) =>
                            params.row.ontologyList.length > 1 ? (
                                index === params.row.ontologyList.length - 1 ? (
                                    <span>{item.onto_manage_title} </span>
                                ) : (
                                    <span>{item.onto_manage_title} / </span>
                                )
                            ) : (
                                <span>{item.onto_manage_title}</span>
                            )
                        )
                        : 'N/A';

                return (
                    <Box sx={{ textWrap: 'wrap', lineHeight: '1.2', width: '120px' }}>
                        <Tooltip title={ontoList} placement='left' arrow>
                            <Typography
                                component='p'
                                sx={{
                                    textOverflow: 'ellipsis',
                                    fontSize: '16px !important',
                                    fontWeight: '400',
                                    lineHeight: '1.5',
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                }}
                            >
                                {ontoList}
                            </Typography>
                        </Tooltip>
                    </Box>
                );
            },
        },
        {
            field: 'start_date',
            headerName: 'Maintenance Date',
            flex: 1,
            sortable: true,
            resizable: false,
            customFilterReq: true,
            headerAlign: 'left',
            align: 'left',
            minWidth: 200,
            width: '200px',
            renderCell: (params: any) => {
                return (
                    <Typography
                        component='p'
                        variant='subtitle1'
                        sx={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}
                    >
                        {params.value ? dayjs.utc(`${params.value} ${params.row.mt_time}`).local().format('MMM D, YYYY hh:mm A') : ''}
                    </Typography>
                );
            },
        },
        {

            field: 'priority',
            headerName: 'Priority',
            flex: 1,
            sortable: true,
            resizable: false,
            colType: 'custom',
            headerAlign: 'left',
            align: 'left',
            customDropdownFilterReq: true,
            options: progressOptions,
            minWidth: 100,
            width: '200px',
            renderCell: (params: any) => {
                return (
                    <>
                        <Chip
                            label={priorityEnums[params.value]}
                            className={priorityEnums[params.value]}
                            variant='outlined'
                            sx={{ border: 'none', backgroundColor: 'transparent !important'}}
                        />
                    </>
                );
            },
        },
        {
            field: 'mt_status',
            headerName: 'Status',
            flex: 1,
            sortable: true,
            resizable: false,
            colType: 'custom',
            headerAlign: 'left',
            align: 'left',
            customDropdownFilterReq: true,
            options: progressOptions,
            minWidth: 100,
            width: '200px',
            renderCell: (params: any) => {
                return (
                    <>
                        <Chip
                            label={params.value.replace('_', " ")}
                            className={params.value}
                            variant='outlined'
                            sx={{ padding: '0px 8px 0px 8px!important', width: '130px' }}
                        />
                    </>
                );
            },
        },
        {
            field: 'actions',
            headerName: 'ACTIONS',
            sortable: false,
            headerAlign: 'left',
            align: 'left',
            customFilterReq: false,
            width: '200px',
            renderCell: (params: any) => {
                const disableUpdate = false;
                const disableDelete = false;
                return (
                    <Box sx={{
                        display: 'flex',
                        gap: '16px'
                    }}>
                        <IconButton disableRipple sx={{ padding: 0 }} onClick={() => { onPlanNavigate('view', params.row.mt_id) }} disabled={disableUpdate}>
                            <ViewIcon
                                style={{
                                    cursor: 'pointer',
                                    width: 24,
                                    height: 24,
                                    opacity: disableUpdate ? 0.5 : 1,
                                }}
                            />
                        </IconButton>
                        <IconButton disableRipple sx={{ padding: 0 }} onClick={() => {
                            onPlanNavigate('edit', params.row.mt_id)
                        }} disabled={disableUpdate}>
                            <CreateIcon
                                style={{
                                    cursor: 'pointer',
                                    width: 24,
                                    height: 24,
                                    opacity: disableUpdate ? 0.5 : 1,
                                }}
                            />
                        </IconButton>
                        <IconButton disableRipple sx={{ padding: 0 }} onClick={() => handleMultipleActions(params.row, 'delete')} disabled={disableDelete}>
                            <DeleteIcon
                                style={{
                                    cursor: 'pointer',
                                    width: 24,
                                    height: 24,
                                    opacity: disableDelete ? 0.5 : 1,
                                }}
                            />
                        </IconButton>
                        <IconButton disableRipple sx={{ padding: 0 }} onClick={() => handleMultipleActions(params.row, 'assign')} disabled={disableUpdate}>
                            <AssignIcon
                                style={{
                                    cursor: 'pointer',
                                    width: 24,
                                    height: 24,
                                    opacity: disableUpdate ? 0.5 : 1,
                                }}
                            />
                        </IconButton>

                    </Box>
                );
            },
        },
        {
            field: 'assigned_to_name',
            headerName: 'Assign Engineer',
            flex: 1,
            sortable: true,
            resizable: false,
            colType: 'custom',
            headerAlign: 'left',
            align: 'left',
            customDropdownFilterReq: true,
            options: [],
            minWidth: 100,
            width: '210px',
            renderCell: (params: any) => {
                return (
                    <>
                        {(params.value && params.value != '') ? <Typography
                            component='span'
                            sx={CustomStyle.cellText}
                            fontWeight={400}
                        >
                            {params.value}
                        </Typography> : <Typography
                            component='span'
                            sx={CustomStyle.cellText}
                            fontWeight={400}
                        >
                            Not Assigned
                        </Typography>}
                    </>

                );
            },
        }
    ];

    const handleMultipleActions = (payload: any, type: string) => {
        if (type === 'assign') {
            setAssignTaskData({ ...payload, ontologyList: getOntologyData(payload.onto_manage_id), });
            setAssignTaskModal(true);
        } else if (type === 'delete') {
            setConfirmDeletePopup({ show: true, mt: payload });

        } else if (type == 'warning') {

        } else if (type == 'success') {

        } else if (type == 'confirm') {

        }
    };

    const handleToggle = (payload: any, status: any) => {
        if (status) {
            const newObj: any = { id: payload.mt_id, enabled: true };
        } else {
            const newObj: any = { id: payload.mt_id, enabled: false };
        }
    };

    const handleTabChange = (e: any, value: any) => {
        setSelectedTab(value);
        setFilterObj({
            mt_name: '',
            last_task_date: '',
            next_task_date: '',
            mt_status: [],
            is_active: [],
            assigned_to: [],
            priority: [],
            ontology: ''
        });
        setSortingModel({ field: '', sort: '' });
        dispatchMaintenanceRequest({
            mt_filter: value,
            mt_name: '',
            last_task_date: '',
            next_task_date: '',
            priority: '',
            assigned_to: '',
            is_active: '',
            mt_status: '',
            ontology: '',
            field: '',
            sort: ''
        });
        if (value === 'corrective') {
            navigate('/maintenance-management/plan-list/corrective');
        } else {
            navigate('/maintenance-management/plan-list');
        }
    };

    const renderFormModal = () => (
        <AssignTask
            isOpen={assignTaskModal}
            assignTaskData={assignTaskData}
            closeModal={() => { setAssignTaskModal(false) }}
            engineers={engineers}
        />
    );

    const renderAlertModal = () => (
        <>
            <PopUp
                title={popupData?.title}
                open={popupData?.show}
                icon={popupData?.icon}
                message={popupData?.message}
                confirmation
                confirmLabel={popupData?.confirmLabel}
                onConfirm={popupData?.onConfirm}
                cancel={popupData?.cancel}
                cancelLabel={popupData?.cancelLabel}
                onCancel={popupData.onCancel ? popupData.onCancel : () => { }}
                onClose={popupData.onClose ? popupData.onClose : () => { }}
                data={popupData.data}
            />
            <PopUp
                open={confirmDeletePopup.show}
                icon={<AlertIcon color={palette.warning.main} />}
                message='Are you sure you want to delete the maintenance plan?'
                cancel={true}
                confirmation={true}
                cancelLabel='No'
                confirmLabel='Yes'
                onClose={() => { setConfirmDeletePopup({ show: false, mt: {} }); setDeletePlanOccurance(''); }}
                onCancel={() => { setConfirmDeletePopup({ show: false, mt: {} }); setDeletePlanOccurance(''); }}
                onConfirm={() => {
                    const payload: any = {
                        mt_id: confirmDeletePopup.mt.mt_id,
                        preference: deletePlanOccurance ? deletePlanOccurance : '',
                        current_task_date: deletePlanOccurance === 'occurrence' && confirmDeletePopup.mt.current_task_date ? confirmDeletePopup.mt.current_task_date : null,
                        next_date: confirmDeletePopup.mt.next_task_date ? confirmDeletePopup.mt.next_task_date : '',
                        last_date: confirmDeletePopup.mt.last_task_date ? confirmDeletePopup.mt.last_task_date : '',
                    };

                    if (confirmDeletePopup.mt.mt_id > 0) {
                        dispatch(maintenanceManagementActions.deletePlanRequest(payload));
                        setConfirmDeletePopup({ show: false, mt: {} });
                        setDeletePlanOccurance('');
                    }
                }}
            ><Box>
                    {selectedTab === 'preventive' ?
                        <Grid container xs={12} display='flex' alignItems='center' justifyContent='center' mt={2}>
                            <RadioGroup row >
                                <FormControlLabel value="female" control={<RadioComponent sx={{ padding: '0 12px' }} />} name='occurrence' onChange={() => { setDeletePlanOccurance('occurrence') }} label="Occurrence" checked={deletePlanOccurance === 'occurrence'} sx={{
                                    '.MuiFormControlLabel-label': {
                                        fontWeight: 400,
                                        fontSize: '16px'
                                    },
                                }} />
                                <FormControlLabel value='Series' control={<RadioComponent sx={{ padding: '0 12px' }} />} label="Series" name='occurrence' onChange={() => { setDeletePlanOccurance('series') }} checked={deletePlanOccurance === 'series'} sx={{
                                    '.MuiFormControlLabel-label': {
                                        fontWeight: 400,
                                        fontSize: '16px'
                                    }
                                }} />
                            </RadioGroup>
                        </Grid>
                        : <></>}
                </Box>
            </PopUp>
        </>
    );

    const pageRedirect = (params: any) => {
        navigate(`/maintenance-management/history/${params.mt_id}`);
    }

    useEffect(() => {
        if (deletePlanSuccess) {
            dispatchMaintenanceRequest({})
        }
    }, [deletePlanSuccess])

    return (
        <>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <Box sx={{ width: '100%' }}>
                    <OntologySelector
                        padding='0'
                        ontoManageId={selectedOntology || null}
                        ontologyData={ontologyData}
                        showLayout={true}
                        hideBottomRow={true}
                        onOntoFilterChange={getOntoSelectedValue}
                        hideLine={true}
                    // disabled={readOnly}
                    // reset={resetOntology}
                    />
                </Box>
                <Box sx={{ display: 'flex', pl: '4px' }}>
                    <VrLine style={{ color: themeData.palette.customBorderColor.main }} />
                    <CalendarDateRange
                        defRange={'Custom Range'}
                        defStartDate={new Date(new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7))}
                        defEndDate={new Date(new Date(today.getFullYear(), today.getMonth(), today.getDate() + 7))}
                        getSelectedDate={(date: any) => {
                            setDateRange(date);
                            dispatchMaintenanceRequest({
                                start_date: date.start_date,
                                end_date: date.end_date,
                            });
                        }}
                    />
                </Box>
            </Box>
            <Container
                maxWidth={false}
                disableGutters
                sx={{ boxShadow: '0px 0px 14px 0px rgba(0, 0, 0, 0.02)', borderRadius: '18px' }}
            >
                <Paper
                    sx={{
                        margin: 'auto',
                        boxShadow: '0px 0px 14px 0px #0000000D',
                        borderRadius: '18px',
                        border: `1px solid ${themeData.palette.customBorderColor.main}`,
                        marginTop: '24px',
                        overflow: 'hidden'
                    }}
                >
                    <Grid
                        container
                        sx={{
                            paddingInline: 3,
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            borderRadius: '18px 18px 0px 0px',
                            borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                            backgroundColor: lightOrdarkColor(themeData.palette.background.default) === 'dark' ? lighten(themeData.palette.background.default, 0.05) : lighten(themeData.palette.background.default, 0.9),
                        }}
                    >
                        <Tabs value={selectedTab} onChange={handleTabChange}>
                            <Tab label='Preventive Maintenance' value={'preventive'} sx={{ paddingInline: 3 }} />
                            <Tab label='Corrective Maintenance' value={'corrective'} sx={{ paddingInline: 3 }} />
                        </Tabs>
                        <Grid
                            sx={{
                                '@media (min-width:300px) and (max-width:1365px)': {
                                    paddingTop: '16px',
                                    paddingBottom: '16px',
                                },
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                gap: '10px'
                            }}
                        >
                            <Button
                                variant='contained'
                                onClick={() => {
                                    navigate('/maintenance-management/plan-list/add', {
                                        state: {
                                            tab: selectedTab,
                                            from: selectedTab === 'corrective' ? 'plan-list/' + selectedTab : 'plan-list/',
                                            breadCrumbsName: 'Maintenance Plan',
                                        },
                                    });
                                }}
                            >
                                <PlusCircleIcon />
                                Add New
                            </Button>
                        </Grid>
                    </Grid>
                    <Box>
                        <CustomDataTable
                            rows={maintenanceData}
                            columns={selectedTab === 'preventive' ? preventiveColumns : correctiveColumns}
                            filterRow={selectedTab === 'preventive' ? filterRow : correctiveFilterRow}
                            tableHeight='calc(100vh - 350px)'
                            noRowsLabel="No Plans"
                            loading={isMaintenanceListLoading || updateMaintenancePlanLoading}
                            isServerPagination
                            totalRowCount={maintenancePlanTotalCount}
                            page={maintenancePlanPageNumber}
                            onPagination={(pageSize: number, pageNumber: number) => {
                                dispatchMaintenanceRequest({ limit: pageSize, page: pageNumber });
                            }}
                            onSorting={({ field, sort }: { field: string; sort: string }) => {
                                const getFieldName: FieldNameTypes = {
                                    mt_name: 'mt_name',
                                    onto_manage_id: 'onto_manage_id',
                                    last_task_date: 'last_task_date',
                                    next_task_date: 'next_task_date',
                                    is_active: 'is_active',
                                    mt_status: 'mt_status',
                                    assign_to: 'assign_to',
                                    priority: 'priority',
                                    start_date: 'start_date',
                                    assigned_to_name: 'assigned_to'
                                };
                                const sortModel = { field: getFieldName[field as keyof FieldNameTypes], sort };
                                dispatchMaintenanceRequest({
                                    limit: DEFAULT_PAGE_SIZE,
                                    page: maintenancePlanPageNumber,
                                    ...sortModel,
                                });
                                setSortingModel(sortModel);
                            }}
                            getRowId={(row: any, idx: number) => `${row.mt_name}-${idx}`}
                        />
                    </Box>
                </Paper>
            </Container>
            {assignTaskModal && renderFormModal()}
            {renderAlertModal()}
        </>
    )
}

const mapStateToProps = (state: any) => ({
    ontoManages: state.ontologyMaster.OntoManages,
    ontologyData: state.ontologyMaster.ontologyData,
    ontologies: state.ontologyMaster.ontologyMgmntData,
    engineers: state.maintenanceManagement.engineers,
    isMaintenanceListLoading: state.maintenanceManagement.isMaintenanceTaskListLoading,
    maintenancePlanData: state.maintenanceManagement.maintenanceTaskPlanData,
    maintenancePlanPageNumber: state.maintenanceManagement.maintenanceTaskPlanPageNumber,
    maintenancePlanTotalCount: state.maintenanceManagement.maintenanceTaskPlanTotalCount,
    deletePlanSuccess: state.maintenanceManagement.deletePlanSuccess,
    updateMaintenancePlanLoading: state.maintenanceManagement.updateMaintenancePlanLoading,
    updateMaintenancePlanSuccess: state.maintenanceManagement.updateMaintenancePlanSuccess,
});

export default connect(mapStateToProps)(MaintenancePlans);
